import React, { Component } from "react";

import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ApplicatedQuestionItemsMenu from "./ApplicatedQuestionItemsMenu/ApplicatedQuestionItemsMenu";
import { logout } from "../../actions/baseActions";
import { showHelpdesk } from "../../actions/noteActions";
import TextEditor from "../TextEditor/TextEditor";
import TextEditorReadOnly from "../TextEditorReadOnly/TextEditorReadOnly";

import "./styles.css";

class ApplicatedQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: true,
      loading: true,

      id: undefined,
      typeId: 1,
      renderedtype: undefined,
      questionDescription: undefined,
      // grade: undefined,
      author: undefined,
      year: undefined,
      // difficultyLevel: undefined,
      items: [],
      questionFeedback: undefined,
      questionFeedbackOn: false,

      prototype: this.props.prototype,
      listApplication: this.props.listApplication,
      finished: this.props.finished || false,

      userAnswer: [],
      // correction: undefined,
      userTextAnswer: '[{"type":"paragraph","children":[{"text":""}]}]',
      answer: []
    };

    this.answerChanger = this.changeAnswer.bind(this);
    this.changeQuestionTextAnswer.bind(this);
  }

  componentDidMount() {
    this.pullQuestion();
  }

  pullQuestion() {
    // axios
    //   .get(`${URL.api}evaluation/type_question/list`, {
    //     headers: { authorization: `Bearer ${this.props.user.token}` }
    //   })
    //   .then(resp => {
    //     if (resp.data.success) {
    //       this.setState({ types: resp.data.data });
    //     }
    //   });

    const feedbackOn =
      this.props.feedback &&
      this.props.feedback !== '[{"type":"paragraph","children":[{"text":""}]}]';

    const answer = this.props.options?.map(item => ({
      id: item.id,
      answer: item.checked_value
    }));
    const userAnswer = this.props.options?.map(answer => ({
      id: answer.id,
      answer: answer.checked_value
    }));
    let userTextAnswer;
    if (this.props.userAnswer && "valor" in this.props.userAnswer) {
      userTextAnswer = this.props.userAnswer.valor;
    } else {
      if (this.props.userAnswer?.textAnswer !== "Sem resposta") {
        userTextAnswer = this.props.userAnswer?.textAnswer
          ? this.props.userAnswer?.textAnswer
          : '[{"type":"paragraph","children":[{"text":""}]}]';
      } else {
        userTextAnswer = '[{"type":"paragraph","children":[{"text":""}]}]';
      }
    }

    this.setState(
      () => ({
        loading: false,

        id: this.props.id,
        typeId: this.props.typeId,
        questionDescription: this.props.questionDescription,
        // grade: this.props.grade,
        author: this.props.author,
        year: this.props.year,
        // difficultyLevel: this.props.difficulty_level_id,
        items: this.props.options,
        questionFeedback: this.props.feedback,
        questionFeedbackOn: feedbackOn,

        answer,
        userAnswer,
        userTextAnswer
      }),
      () => this.renderType()
    );
  }

  changeAnswer(itemId, checkValue) {
    if (this.props.finished || this.state.finished) return;

    // eslint-disable-next-line react/no-access-state-in-setstate
    const newAnswerArray = this.state.userAnswer;
    const itemIndex = newAnswerArray.findIndex(item => item.id === itemId);
    if (this.state.typeId === 2) {
      newAnswerArray[itemIndex].answer = true;
      checkValue = true;
    } else {
      newAnswerArray[itemIndex].answer = checkValue;
    }

    newAnswerArray.forEach(item => {
      if (this.state.typeId === 2 && item.id !== itemId) {
        item.answer = false;
      }
    });
    const correction =
      // eslint-disable-next-line react/no-access-state-in-setstate
      JSON.stringify(this.state.answer) === JSON.stringify(newAnswerArray);

    if (this.state.listApplication)
      this.props.listAnswerChanger(itemId, this.state.id, checkValue);
    // eslint-disable-next-line react/no-unused-state
    this.setState({ userAnswer: newAnswerArray, correction });
  }

  changeQuestionTextAnswer = newAnswer => {
    if (this.props.finished || this.state.finished) return;
    if (this.state.flag) {
      this.setState({ flag: false });

      const strAnswer = JSON.stringify(newAnswer);
      const answerData = {
        textAnswer: strAnswer,
        itemsAnswer: {
          items: [],
          answers: []
        }
      };
      // deixar questoes abertas como erradas se não
      if (this.state.listApplication) {
        this.props.listAnswerChanger(false, this.state.id, answerData);
      }
      this.setState({ userTextAnswer: strAnswer }, () => {
        this.setState({ flag: true });
      });
      localStorage.setItem(`question-${this.props.id}-answer`, newAnswer);
    }
  };

  renderType() {
    const typeIndex = this.props.types?.findIndex(
      type => type.id === this.props.typeId
    );
    let renderedType = typeIndex ? this.props.types[typeIndex]?.name : "";
    this.setState({ renderedtype: renderedType });
  }

  render() {
    return (
      <>
        {!this.state.loading ? (
          <div
            className={`applicated-question-container ${
              this.props.className || ""
            }`}
          >
            <section className="applicated-question-idetification-section">
              <section className="applicated-question-source-year-section">
                <p>
                  {this.state.renderedtype} (
                  {this.state.author && `${this.state.author}, `}
                  {this.state.year})
                </p>
              </section>
              <p className="applicated-question-type-indicator d-flex align-items-center">
                <CDropdown className="ml-3">
                  <CDropdownToggle
                    color="white"
                    className="card-header-action remove-caret"
                  >
                    <i className="fa fa-ellipsis-v"></i>
                  </CDropdownToggle>
                  <CDropdownMenu placement="bottom-start">
                    <CDropdownItem
                      onClick={() =>
                        this.props.showHelpdesk(
                          25,
                          this.props.questionId,
                          this.props.listId
                        )
                      }
                    >
                      Tirar dúvida
                    </CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
              </p>
            </section>
            {this.props.questionOrder && <h3>{this.props.questionOrder}ª)</h3>}
            <TextEditorReadOnly
              editorType={{ name: "description", id: 1 }}
              questionId={this.props.questionId}
              textContent={this.state.questionDescription}
            />
            {this.state.typeId === 1 ? (
              // comment: aqui que chama em caso de questões discursivas
              <TextEditor
                editorType={{ name: "answer", id: 4 }}
                questionId={this.state.id}
                changeQuestionTextAnswer={this.changeQuestionTextAnswer}
                textContent={this.state.userTextAnswer}
              />
            ) : (
              <ApplicatedQuestionItemsMenu
                showAnswers={this.props.showAnswers}
                questionType={this.state.typeId}
                items={this.state.items}
                userAnswer={this.state.userAnswer}
                answerChanger={this.answerChanger}
                finished={this.props.finished || this.state.finished}
              />
            )}
            {(this.props.finished || this.state.finished) &&
              this.state.questionFeedbackOn && (
                <TextEditorReadOnly
                  editorType={{ name: "feedback", id: 2 }}
                  questionId={this.props.questionId}
                  textContent={this.state.questionFeedback}
                />
              )}
            {this.state.prototype && (
              <section className="applicated-question-prototype-edit-finish-section">
                {!this.state.finished ? (
                  <>
                    {this.props.editable !== false && (
                      <button
                        className="edit-applicated-question-button"
                        onClick={() =>
                          this.props.history.push(
                            `/question/create/${this.state.id}`
                          )
                        }
                      >
                        <p>Editar</p>
                      </button>
                    )}
                    <button
                      className="finish-applicated-question-button"
                      onClick={() => this.setState({ finished: true })}
                    >
                      <i className="fa fa-check mr-2"></i>
                      <p>Mostrar resposta</p>
                    </button>
                  </>
                ) : (
                  <React.Fragment>
                    <>
                      <button
                        className="edit-applicated-question-button"
                        onClick={() => this.setState({ finished: false })}
                      >
                        <p>Voltar</p>
                      </button>
                      {this.props.editable !== false && (
                        <button
                          className="finish-applicated-question-button"
                          onClick={() =>
                            this.props.history.push(
                              `/question/create/${this.state.id}`
                            )
                          }
                        >
                          <p>Editar</p>
                        </button>
                      )}
                    </>
                    )
                  </React.Fragment>
                )}
              </section>
            )}
          </div>
        ) : (
          <div
            className={`applicated-question-container ${
              this.props.className || ""
            }`}
          >
            <div className="d-flex justify-content-between">
              <div
                className="applicated-question-skeleton"
                style={{ width: "28%", height: "1rem", margin: "8px 0" }}
              />
              <div
                className="applicated-question-skeleton"
                style={{ width: "32%", height: "1rem", margin: "8px 0" }}
              />
            </div>
            <div className="my-2">
              <div
                className="applicated-question-skeleton"
                style={{ width: "90%", height: "1.5rem", margin: "8px 0" }}
              />
              <div
                className="applicated-question-skeleton"
                style={{ width: "30%", height: "1.5rem", margin: "8px 0" }}
              />
            </div>
            <div
              className="applicated-question-skeleton"
              style={{ width: "100%", height: "8rem", margin: "8px 0" }}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, showHelpdesk }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicatedQuestion);
